"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSameDate = isSameDate;
exports.isAfterDate = isAfterDate;
exports.isBeforeDate = isBeforeDate;
exports.isBetweenDates = isBetweenDates;
exports.getDaysInMonth = getDaysInMonth;
exports.buildJSDate = buildJSDate;
exports.sortSelectedDates = sortSelectedDates;

var _isDate = _interopRequireDefault(require("lodash/isDate"));

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * Evaluates two JavaScript Dates for existence and similarity. Time doesn't matter, only dates.
 * @param  {Date}    date1 A JavaScript Date
 * @param  {Date}    date2 A JavaScript Date
 * @return {Boolean}       If both dates exist and have the same year, month, and date.
 */


function isSameDate(date1, date2) {
  return !!(date1 && date2 && date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate());
}
/**
 * Evaluates two JavaScript Dates for existence and order. Time doesn't matter, only dates.
 * @param  {Date}    setDate    The date to use as the base
 * @param  {Date}    dateToTest The date to evaluate
 * @return {Boolean}            If both dates exist and the dateToTest is after the setDate.
 */


function isAfterDate(setDate, dateToTest) {
  return !!(setDate && dateToTest && setDate < dateToTest && !isSameDate(setDate, dateToTest));
}
/**
 * Evaluates two JavaScript Dates for existence and order. Time doesn't matter, only dates.
 * @param  {Date}    setDate    The date to use as the base
 * @param  {Date}    dateToTest The date to evaluate
 * @return {Boolean}            If both dates exist and the dateToTest is before the setDate.
 */


function isBeforeDate(setDate, dateToTest) {
  return !!(setDate && dateToTest && setDate > dateToTest && !isSameDate(setDate, dateToTest));
}
/**
 * Evaluates three JavaScript Dates for existence and order. Time doesn't matter, only dates.
 * @param  {Date}    setDate1   The earlier date to use as the base
 * @param  {Date}    setDate2   The later date to use as the base
 * @param  {Date}    dateToTest The date to evaluate
 * @return {Boolean}            If all dates exist and the dateToTest is between the set dates.
 */


function isBetweenDates(setDate1, setDate2, dateToTest) {
  return !!(setDate1 && setDate2 && dateToTest && isAfterDate(setDate1, dateToTest) && isBeforeDate(setDate2, dateToTest));
}
/**
 * Evaluates and returns the number of days in the month of the provided JS date. Compensates for
 * leap years.
 */


function getDaysInMonth(jsDate) {
  // This creates a date that is the last day of the month of the provided date,
  // ... because JavaScript.
  var date = new Date(jsDate.getFullYear(), jsDate.getMonth() + 1, 0);
  return date.getDate();
}

function buildJSDate(date) {
  if (!date) {
    return new Date();
  }

  if ((0, _isDate.default)(date)) {
    return new Date(date);
  }

  var year = date.year,
      month = date.month;
  return new Date(year, month - 1, (0, _get.default)(date, 'date', 1));
}
/**
 * Sort an array of two dates, putting falsy values at the end
 * @param  {TSelectedDates}    selectedRange   An array of two dates representing a range
 * @return {Boolean}           An sorted array of two dates
 */


function sortSelectedDates(selectedRange) {
  var _selectedRange = _slicedToArray(selectedRange, 2),
      firstDate = _selectedRange[0],
      secondDate = _selectedRange[1];

  if (!firstDate && !secondDate || firstDate && !secondDate) {
    return selectedRange;
  }

  if (!firstDate && secondDate || firstDate && secondDate && isAfterDate(secondDate, firstDate)) {
    return [secondDate, firstDate];
  }

  return selectedRange;
}